import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";

import styled from "styled-components";
import { OpenAdminAtomicBanner } from "./OpenAdminAtomicBanner";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { BasicBannerProps } from "./OpenAdminBannerByStatus";
import { Button } from "src/apps/components/button/Button";
import { colors } from "@permisso/permisso-components";

export const ClosedOpenAdminBanner = ({
  title,
  description,
  buttonText,
  onButtonClick,
  isLoading,
  isDisabled,
}: BasicBannerProps) => {
  const { t } = useTranslations();
  return (
    <OpenAdminAtomicBanner
      title={t(title)}
      description={description ? t(description) : undefined}
      borderColor={colors.grey800}
      leftAlign="flex-start"
      leftComponent={
        <StatusIconContainer>
          <Icon size={ICON_SIZES.s24} color={colors.grey700} path={ICON_PATHS.CIRCLE_MINUS} />
        </StatusIconContainer>
      }
      rightComponent={
        buttonText ? (
          <Button
            onClick={onButtonClick ?? (() => {})}
            text={t(buttonText)}
            isLoading={isLoading}
            disabled={isDisabled}
          />
        ) : undefined
      }
    />
  );
};

const StatusIconContainer = styled.div`
  display: flex;
  align-items: center;
`;
